export const GET_ALLOCATOR_USERS = "ALLOCATOR@GET_ALLOCATOR_USERS";
export const GET_ALLOCATOR_USERS_INIT = "ALLOCATOR@GET_ALLOCATOR_USERS_INIT";
export const GET_ALLOCATOR_USERS_SUCCESS = "ALLOCATOR@GET_ALLOCATOR_USERS_SUCCESS";
export const GET_ALLOCATOR_USERS_FAILED = "ALLOCATOR@GET_ALLOCATOR_USERS_FAILED";

export const GET_ALLOCATOR_CONTACTS = "ALLOCATOR@GET_ALLOCATOR_CONTACTS";
export const GET_ALLOCATOR_CONTACTS_INIT = "ALLOCATOR@GET_ALLOCATOR_CONTACTS_INIT";
export const GET_ALLOCATOR_CONTACTS_SUCCESS = "ALLOCATOR@GET_ALLOCATOR_CONTACTS_SUCCESS";
export const GET_ALLOCATOR_CONTACTS_FAILED = "ALLOCATOR@GET_ALLOCATOR_CONTACTS_FAILED";

export const IMPORT_ALLOCATOR_CONTACT = "ALLOCATOR@IMPORT_ALLOCATOR_CONTACT";
export const IMPORT_ALLOCATOR_CONTACT_INIT = "ALLOCATOR@IMPORT_ALLOCATOR_CONTACT_INIT";
export const IMPORT_ALLOCATOR_CONTACT_SUCCESS = "ALLOCATOR@IMPORT_ALLOCATOR_CONTACT_SUCCESS";
export const IMPORT_ALLOCATOR_CONTACT_FAILED = "ALLOCATOR@IMPORT_ALLOCATOR_CONTACT_FAILED";

export const SEND_ALLOCATOR_INVITATION_EMAIL = "ALLOCATOR@SEND_ALLOCATOR_INVITATION_EMAIL";
export const SEND_ALLOCATOR_INVITATION_EMAIL_INIT = "ALLOCATOR@SEND_ALLOCATOR_INVITATION_EMAIL_INIT";
export const SEND_ALLOCATOR_INVITATION_EMAIL_SUCCESS = "ALLOCATOR@SEND_ALLOCATOR_INVITATION_EMAIL_SUCCESS";
export const SEND_ALLOCATOR_INVITATION_EMAIL_FAILED = "ALLOCATOR@SEND_ALLOCATOR_INVITATION_EMAIL_FAILED";

export const CREATE_ALLOCATOR_NETWORKS = "ALLOCATOR@CREATE_ALLOCATOR_NETWORKS";
export const CREATE_ALLOCATOR_NETWORKS_INIT = "ALLOCATOR@CREATE_ALLOCATOR_NETWORKS_INIT";
export const CREATE_ALLOCATOR_NETWORKS_SUCCESS = "ALLOCATOR@CREATE_ALLOCATOR_NETWORKS_SUCCESS";
export const CREATE_ALLOCATOR_NETWORKS_FAILED = "ALLOCATOR@CREATE_ALLOCATOR_NETWORKS_FAILED";

export const UPDATE_ALLOCATOR_NETWORKS = "ALLOCATOR@UPDATE_ALLOCATOR_NETWORKS";
export const UPDATE_ALLOCATOR_NETWORKS_INIT = "ALLOCATOR@UPDATE_ALLOCATOR_NETWORKS_INIT";
export const UPDATE_ALLOCATOR_NETWORKS_SUCCESS = "ALLOCATOR@UPDATE_ALLOCATOR_NETWORKS_SUCCESS";
export const UPDATE_ALLOCATOR_NETWORKS_FAILED = "ALLOCATOR@UPDATE_ALLOCATOR_NETWORKS_FAILED";

export const DELETE_ALLOCATOR_NETWORKS = "ALLOCATOR@DELETE_ALLOCATOR_NETWORKS";
export const DELETE_ALLOCATOR_NETWORKS_INIT = "ALLOCATOR@DELETE_ALLOCATOR_NETWORKS_INIT";
export const DELETE_ALLOCATOR_NETWORKS_SUCCESS = "ALLOCATOR@DELETE_ALLOCATOR_NETWORKS_SUCCESS";
export const DELETE_ALLOCATOR_NETWORKS_FAILED = "ALLOCATOR@DELETE_ALLOCATOR_NETWORKS_FAILED";